import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { WordsProvider } from '../../clients/words-ui';
import type { ScreenWords } from '../../clients/api';
import type { NashMessendzher } from '../api';
import { NashiMessendzhery } from './NashiMessendzhery';
import { usePermissions } from '../../auth/usePermissions';

export type MessengerCard = { vid: 'klientka' | 'zapis' | 'lid'; id: number };

/** A known card is sufficient; neither fetching nor copying creates a conversation. */
export function MessendzheryKlientki({ card }: { card: MessengerCard }) {
  const permissions = usePermissions();
  const allowed = permissions.isSuperAdmin || permissions.can('visit.card.messengers');
  const path = `/sms/messenger-card/${card.vid}/${card.id}`;
  const query = useQuery({
    queryKey: ['nashi-messendzhery', card.vid, card.id],
    queryFn: async () => (await apiClient.get<{ rows: NashMessendzher[]; words: ScreenWords }>(path)).data,
    staleTime: 0,
    retry: false,
    enabled: allowed,
  });
  // No previous recipient's data during a card change, including its SMS action.
  if (!allowed || !query.data || query.isError) return null;
  return <WordsProvider hints={{}} words={query.data.words}>
    <NashiMessendzhery key={path} rows={query.data.rows}
      onSms={async (row, intent) => (await apiClient.post<{ ok: boolean }>(`${path}/${row.channel_id}`, { intent })).data} />
  </WordsProvider>;
}
